function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.924)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.528 2.063)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M417.109,100.873a1.536,1.536,0,0,1-2.014.6l-1.985.6a3.319,3.319,0,0,0,5.983-1.8Z",
  transform: "translate(-412.462 -96.74)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M414.5,99.188a1.546,1.546,0,0,1,1.85-.556l2.036-.611a3.314,3.314,0,0,0-5.921,1.778Z",
  transform: "translate(-412.462 -96.74)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M406.883,101.476a4.908,4.908,0,0,1-.211-1.4,5.4,5.4,0,0,1,2.126-4.188.624.624,0,0,0,0-1.006.975.975,0,0,0-.618-.209h0a.978.978,0,0,0-.617.209h0a6.452,6.452,0,0,0-2.325,7.084Z",
  transform: "translate(-404.934 -94.677)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M408.087,103.583l-1.7.51a7.879,7.879,0,0,0,1.174,1.18.978.978,0,0,0,.617.209h0a.975.975,0,0,0,.618-.209.623.623,0,0,0,0-1.007A6.5,6.5,0,0,1,408.087,103.583Z",
  transform: "translate(-404.934 -94.677)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.252 1.877)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M409.985,100.544a2.688,2.688,0,0,1-.056-.464,2.972,2.972,0,0,1,1.173-2.311.625.625,0,0,0,0-1.007,1.022,1.022,0,0,0-1.236,0,4.146,4.146,0,0,0-1.557,4.285Z",
  transform: "translate(-408.186 -96.554)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M409.576,103.136c.094.088.187.177.29.261a1.022,1.022,0,0,0,1.236,0,.647.647,0,0,0,.256-.5.6.6,0,0,0-.067-.274Z",
  transform: "translate(-408.186 -96.554)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(17.559)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M424.642,98.61a4.927,4.927,0,0,1,.233,1.47,5.4,5.4,0,0,1-2.126,4.187.624.624,0,0,0,0,1.006.975.975,0,0,0,.618.209h0a.978.978,0,0,0,.617-.209h0a6.446,6.446,0,0,0,2.3-7.158Z",
  transform: "translate(-422.493 -94.677)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M423.4,96.513l1.7-.512a7.873,7.873,0,0,0-1.12-1.115.978.978,0,0,0-.617-.209h0a.975.975,0,0,0-.618.209.623.623,0,0,0,0,1.007A6.424,6.424,0,0,1,423.4,96.513Z",
  transform: "translate(-422.493 -94.677)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(15.255 1.877)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M421.553,99.537a2.734,2.734,0,0,1,.065.543,2.972,2.972,0,0,1-1.173,2.31.625.625,0,0,0,0,1.007,1.022,1.022,0,0,0,1.236,0,4.136,4.136,0,0,0,1.535-4.359Z",
  transform: "translate(-420.189 -96.554)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M421.9,96.963c-.074-.067-.143-.136-.223-.2a1.022,1.022,0,0,0-1.236,0,.647.647,0,0,0-.256.5.6.6,0,0,0,.048.2Z",
  transform: "translate(-420.189 -96.554)"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 1.068)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M403.678,104.348a.668.668,0,0,1-.192-1.307l24.194-7.268a.668.668,0,1,1,.384,1.279l-24.194,7.267A.649.649,0,0,1,403.678,104.348Z",
  transform: "translate(-403.01 -95.745)"
}));

function SvgActiveOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#e35c5c",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.531,
    height: 10.805,
    viewBox: "0 0 25.531 10.805",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveOff);
export default __webpack_public_path__ + "static/media/active_off.f4f7b7586edf24a22f5476e7fd40e987.svg";
export { ForwardRef as ReactComponent };